module.exports = __webpack_public_path__ + "img/parkinglist2.6617e438.png";